<app-card-content [border]="false" icon="pi pi-shield" title="Comissões" subtitle="Composição de comissões do prestador">
    <app-tab-container [options]="options" [(selected)]="selected" [useHeader]="false" (onChanged)="onTipoComissaoAlterado($event)">
        <app-tab-content value="ETICA"><ng-container [ngTemplateOutlet]="tabelaComissao"></ng-container></app-tab-content>
        <app-tab-content value="REVISAO_PRONTUARIO"><ng-container [ngTemplateOutlet]="tabelaComissao"></ng-container></app-tab-content>
        <app-tab-content value="REVISAO_OBITO"><ng-container [ngTemplateOutlet]="tabelaComissao"></ng-container></app-tab-content>
        <app-tab-content value="CONTROLE_INFECCAO"><ng-container [ngTemplateOutlet]="tabelaComissao"></ng-container></app-tab-content>
        <app-tab-content value="PGRSS"><ng-container [ngTemplateOutlet]="tabelaComissao"></ng-container></app-tab-content>
        <app-tab-content value="NSP"><ng-container [ngTemplateOutlet]="tabelaComissao"></ng-container></app-tab-content>
    </app-tab-container>
</app-card-content>

<ng-template #tabelaComissao>
    <div class="comissao-toolbar">
        <p-select [(ngModel)]="composicao" [options]="composicoes" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-56" (onChange)="onComposicaoAlterada()" />
        <p-button label="Novo membro" icon="pi pi-plus" (onClick)="novoMembro()" [appCan]="roleEditar" [appCanUf]="pessoa()?.uf" />
    </div>

    <app-custom-table
        [metadata]="tableMetadata"
        [data]="membrosTabela()"
        [columnOrder]="columnOrder"
        [loading]="carregando()"
        [first]="first()"
        [rows]="rows()"
        [totalRecords]="totalRecords()"
        [rowsPerPageOptions]="[10, 15, 20]"
        [showActions]="true"
        [showExpandButton]="true"
        [initialViewMode]="'table'"
        [cardColumns]="2"
        [permissaoUf]="pessoa()?.uf ?? null"
        (onPageChange)="onPaginaAlterada($event)"
    />

    <div class="table-footer">
        <div class="legend-group">
            <div class="legend"><span class="legend-color debt"></span>Médicos Devedores</div>
            <div class="legend"><span class="legend-color deceased"></span>Médicos Falecidos</div>
        </div>
        <span>Total: {{ totalRecords() }}</span>
    </div>
</ng-template>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Membro da comissão de ética do prestador."
    [visible]="dialogVisivel()"
    (visibleChange)="dialogVisivel.set($event)"
    [style]="{ width: 'min(94vw, 640px)' }"
    [appendTo]="'body'"
    [header]="membroEmEdicao() ? 'Editar membro da comissão' : 'Novo membro da comissão'"
>
    <div class="membro-form">
        <div class="membro-form__full">
            <label>Membro *</label>
            <div class="membro-form__search">
                <input pInputText [value]="formulario.nome || 'Selecione um médico'" readonly />
                <p-button label="Pesquisar médico" icon="pi pi-search" severity="secondary" (onClick)="abrirPesquisaMedico()" />
            </div>
        </div>

        <div><label>CRM</label><input pInputText [(ngModel)]="formulario.crm" readonly /></div>
        <div><label>UF</label><input pInputText [(ngModel)]="formulario.ufMembro" readonly /></div>
        <div>
            <label>Cargo</label>
            <p-select [options]="cargos()" optionLabel="cargo" optionValue="idCargo" [(ngModel)]="formulario.idCargo" appendTo="body" placeholder="Selecione o cargo" [showClear]="true" styleClass="w-full" />
        </div>
        <div><label>Entrada *</label><input pInputText type="date" [(ngModel)]="formulario.entrada" /></div>
        <div><label>Saída</label><input pInputText type="date" [(ngModel)]="formulario.saida" /></div>
    </div>

    <ng-template #footer>
        <p-button label="Cancelar" severity="secondary" (onClick)="dialogVisivel.set(false)" />
        <p-button label="Salvar" icon="pi pi-check" [loading]="salvando()" [disabled]="!formulario.idMembro || !formulario.entrada" (onClick)="salvarMembro()" />
    </ng-template>
</p-dialog>

<app-seletor-medico-corpo-clinico [(showDialog)]="pesquisaMedicoDialog" [idPrestador]="pessoa()?.id ?? 0" [ufPrestador]="pessoa()?.uf ?? ''" [excluirMembrosComissaoAtivos]="selected" (medico)="selecionarMedico($event)" />
